import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const modes = {
  schema: 'JSON Schema',
  value: 'Value Example',
  defaults: 'Properties Defaults',
} as const;

export const useActiveMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeMode = useMemo((): keyof typeof modes => {
    const value = searchParams.get('mode');
    if (value && modes[value as keyof typeof modes]) {
      return value as keyof typeof modes;
    }
    return 'schema';
  }, [searchParams]);

  const setActiveMode = useCallback(
    (mode: keyof typeof modes) => {
      searchParams.set('mode', mode);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  return [activeMode, setActiveMode] as const;
};
